<script setup lang="ts">
import HelpButton from '@/components/common/help/HelpButton.vue'
import { useContextualHelp } from '@/composables/useContextualHelp'

const props = defineProps({
  showModal: {
    type: Boolean,
    required: true,
    default: false,
  },
  title: String,
  loading: {
    type: Boolean,
    default: false,
  },
  subModal: {
    type: Boolean,
    default: false,
  },
  maxWidth: {
    type: String,
    default: '5xl',
  },
  overflowY: {
    type: String,
    default: '',
  },
  /** Clé d'aide contextuelle ; active l'aide pendant l'ouverture de la modale. */
  helpKey: {
    type: String,
    default: '',
  },
})

defineEmits(['close', 'save'])

// Aide contextuelle : active la clé tant que la modale est ouverte (no-op si vide).
useContextualHelp(props.helpKey, () => props.showModal)
</script>

<template>
  <div
    v-if="showModal"
    class="z-[1100]"
    :class="{
      'modal modal-open ': true,
      'min-h-screen': !subModal,
      'min-h-full': subModal,
    }"
  >
    <div
      class="modal-box w-11/12"
      :class="{
        'modal-box w-11/12 ': true,
        'max-w-full': maxWidth === 'full',
        'max-w-7xl': maxWidth === '7xl',
        'max-w-6xl': maxWidth === '6xl',
        'max-w-5xl': maxWidth === '5xl',
        'max-w-3xl': maxWidth === '3xl',
        'max-w-2xl': maxWidth === '2xl',
        'max-w-xl': maxWidth === 'xl',
        'max-w-lg': maxWidth === 'lg',
        'max-w-md': maxWidth === 'md',
        'max-w-xs': maxWidth === 'xs',
        'overflow-y-visible': overflowY === 'visible',
      }"
    >
      <button
        @click="$emit('close')"
        class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2 max-lg:"
      >
        ✕
      </button>
      <div class="flex items-center gap-1">
        <h3 class="text-lg font-bold">{{ title }}</h3>
        <HelpButton />
      </div>
      <slot name="content" class=""> </slot>
    </div>
  </div>
</template>
